import { render, staticRenderFns } from "./SellCheckRegistration.vue?vue&type=template&id=efaf1376&"
import script from "./SellCheckRegistration.vue?vue&type=script&lang=js&"
export * from "./SellCheckRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports